import {Injectable} from "@angular/core";
import { HttpParams } from "@angular/common/http";
import {UsanaObject} from "../../usana-object";
import {UrlService} from "../../common/url.service";
import {LoggerService} from "../../common/logger.service";
import {GqlPaymentService} from "../../../checkout/payment/gql-payment.service";
import {Observable} from "rxjs";
import {
    IPayPalAgreementTokenCreationResponse,
    IPayPalPaymentCreationResponse,
    IPayPalPaymentDetailsResponse
} from "./paypal-model";
import {Constants} from "../../constants";
import {PaymentMethodResponse, PaymentSourceInput} from "../../../checkout/models/payment/payment-method";

@Injectable({
    providedIn: "root"
})
export class PayPalService extends UsanaObject {

    constructor(
        loggerService: LoggerService,
        private gqlPaymentService: GqlPaymentService,
        private urlService: UrlService,
    ) {
        super(loggerService);
    }

    createPayPalAgreementToken(pathComponents: string[]): Observable<IPayPalAgreementTokenCreationResponse> {
        const returnPath = pathComponents.join("/");
        const returnUrl = this.urlService.buildCartUxUrl(Constants.PAYPAL_TOKEN_STATE, new HttpParams()
            .set(Constants.PAYPAL_PARAM_RETURN_URL, encodeURIComponent(returnPath)));
        const cancelUrl = this.urlService.buildCartUxUrl(returnPath);
        return this.gqlPaymentService.createPayPalAgreementToken(returnUrl, cancelUrl);
    }

    savePayPalAgreementToken(baToken: string): Observable<PaymentMethodResponse> {
        if (!baToken) {
            throw new Error("agreementToken is required");
        }

        const paymentSource: PaymentSourceInput = {
            payPal: {
                agreementToken: baToken
            }
        } as PaymentSourceInput;
        return this.gqlPaymentService.addPaymentMethod(Constants.PMT_PAYPAL, paymentSource);
    }

    createPayPalPaymentToken(orderId: number): Observable<IPayPalPaymentCreationResponse> {
        const returnUrl = this.urlService.buildCartUxUrl('checkout?paymentMethod=PAYPAL&result=true');
        const cancelUrl = this.urlService.buildCartUxUrl('checkout?paymentMethod=PAYPAL&result=false');
        return this.gqlPaymentService.cartOrderCreatePayPalPayment(orderId, returnUrl, cancelUrl);
    }

    getCartOrderPayPalPaymentDetails(orderId: number, paymentId: string): Observable<IPayPalPaymentDetailsResponse> {
        return this.gqlPaymentService.getCartOrderPayPalPaymentDetails(orderId, paymentId);
    }
}
